import { useEffect } from 'react';
import { clearTemporaryStorage } from '../utils/storageManager';  

/**
 * Custom hook to clear localStorage when user leaves the webpage
 * Clears cart-related data but preserves user authentication
 */
const useClearStorageOnExit = () => {
    const clearApplicationData = () => {
        clearTemporaryStorage();
    };

    useEffect(() => {
        // Handle page unload (when user closes tab/browser or navigates away)
        const handleBeforeUnload = (event) => {
            clearApplicationData();
        };

        // Handle visibility change (when user switches tabs or minimizes browser)
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                // Add a small delay to avoid clearing on quick tab switches
                setTimeout(() => {
                    if (document.visibilityState === 'hidden') {
                        clearApplicationData();
                    }
                }, 2000); // 2 second delay
            }
        };

        // Handle page hide (more reliable than beforeunload on mobile)
        const handlePageHide = () => {
            clearApplicationData();
        };

        // Add event listeners
        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('pagehide', handlePageHide);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup function
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('pagehide', handlePageHide);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    // Return a manual clear function in case needed
    return { clearApplicationData };
};

export default useClearStorageOnExit;
